import { Box, Button, Modal } from "@mui/material";

import BOHeader from "../../organisms/Login/BOHeader";
import BusinessDetails from "../../organisms/Login/BusinessDetails";
import ProductsTable from "../../Pages/businessProfile/ProductsTable";
import React from "react";

interface BOModalProps {
  open: boolean;
  handleClose: () => void;
  step: string;
  handleSkipForNow: () => void;
  handleGoBack: () => void;
  handleContinue: () => void;
  steps: string[];
  businessDataDetails: any;
  setBusinessDataDetails: any;
  currentBusinessProfile: any;
}

const BOModal = ({
  open,
  handleClose,
  step,
  handleSkipForNow,
  handleGoBack,
  handleContinue,
  steps,
  businessDataDetails,
  setBusinessDataDetails,
  currentBusinessProfile,
}: BOModalProps) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflowY: "auto",
        }}
      >
        <Box bgcolor={"#ECEFF1"} padding={3} borderRadius={1}>
          <Box sx={{ width: "1106px" }}>
            <BOHeader
              title={
                step === "offerings" ? "Add Offerings" : "Add Business Details"
              }
              titleVariant="h6"
              subTitle={""}
              activeStep={step === "offerings" ? 1 : 0}
              steps={steps}
            />

            {step === "offerings" ? (
              <ProductsTable currentBusinessProfile={currentBusinessProfile} />
            ) : (
              <BusinessDetails
                businessDataDetails={businessDataDetails}
                setBusinessDataDetails={setBusinessDataDetails}
              />
            )}

            <Box
              display={"flex"}
              gap={1}
              alignItems={"center"}
              marginTop={5}
              sx={{
                justifyContent:
                  step === "offerings" ? "space-between" : "flex-end",
              }}
            >
              {step === "offerings" && (
                <Button
                  sx={{
                    textDecoration: "underline",
                    padding: "0 !important",
                  }}
                  variant="text"
                  onClick={handleSkipForNow}
                  size="large"
                  disableRipple
                  color="primary"
                >
                  Skip for now
                </Button>
              )}
              <Box sx={{ display: "flex", gap: "8px" }}>
                <Button
                  onClick={handleGoBack}
                  variant="text"
                  size="large"
                  color="primary"
                >
                  Go Back
                </Button>
                <Button
                  onClick={handleContinue}
                  variant="contained"
                  size="large"
                  color="primary"
                >
                  Continue
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default BOModal;
